<template>
  <div class="health-detection-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link" style="color: #3498db;">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 页面标题 -->
    <section class="page-header">
      <div class="container">
        <h1>量子健康检测服务</h1>
        <p>基于量子物理学原理的先进健康检测技术</p>
      </div>
    </section>

    <!-- 服务概述 -->
    <section class="service-overview">
      <div class="container">
        <div class="overview-content">
          <div class="overview-text">
            <h2>什么是量子健康检测？</h2>
            <p>量子健康检测是一种基于量子物理学原理的非侵入式健康评估技术。通过检测人体生物电场的变化，分析身体健康状况，预测潜在健康风险。这项技术融合了现代量子物理学、生物学、医学等多学科知识，为健康管理提供了全新的解决方案。</p>
            <p>与传统的体检方式不同，量子检测具有无创、快速、全面的特点，能够在疾病形成早期就发现潜在的健康问题，为预防和干预提供宝贵的时间窗口。</p>
          </div>
          <div class="overview-image">
            <div class="detection-illustration">
              <div class="quantum-wave"></div>
              <div class="human-body"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术原理 -->
    <section class="technology-principle">
      <div class="container">
        <h2 class="section-title">技术原理</h2>
        <div class="principle-grid">
          <div class="principle-card">
            <div class="principle-icon">⚛️</div>
            <h3>量子共振</h3>
            <p>利用量子共振原理，检测人体细胞的电磁波频率，分析器官和组织的健康状况</p>
          </div>
          <div class="principle-card">
            <div class="principle-icon">📊</div>
            <h3>频谱分析</h3>
            <p>通过频谱分析技术，将检测到的生物电信号转化为可视化的健康数据</p>
          </div>
          <div class="principle-card">
            <div class="principle-icon">🧬</div>
            <h3>细胞检测</h3>
            <p>深入细胞层面，检测细胞能量状态和功能活性，评估整体健康水平</p>
          </div>
          <div class="principle-card">
            <div class="principle-icon">🔍</div>
            <h3>风险评估</h3>
            <p>基于大数据分析，预测潜在健康风险，提供个性化的健康建议</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测项目 -->
    <section class="detection-items">
      <div class="container">
        <h2 class="section-title">检测项目</h2>
        <div class="items-grid">
          <div class="item-category">
            <h3>基础健康检测</h3>
            <ul>
              <li>心血管功能评估</li>
              <li>肝肾功能检测</li>
              <li>消化系统分析</li>
              <li>呼吸功能评估</li>
              <li>神经系统检测</li>
            </ul>
          </div>
          <div class="item-category">
            <h3>深度健康筛查</h3>
            <ul>
              <li>内分泌系统评估</li>
              <li>免疫系统分析</li>
              <li>骨骼健康检测</li>
              <li>肌肉功能评估</li>
              <li>代谢状态分析</li>
            </ul>
          </div>
          <div class="item-category">
            <h3>专项检测服务</h3>
            <ul>
              <li>肿瘤风险评估</li>
              <li>慢性病筛查</li>
              <li>过敏原检测</li>
              <li>重金属检测</li>
              <li>营养状况评估</li>
            </ul>
          </div>
          <div class="item-category">
            <h3>个性化检测</h3>
            <ul>
              <li>抗衰老评估</li>
              <li>运动能力分析</li>
              <li>睡眠质量评估</li>
              <li>压力水平检测</li>
              <li>情绪状态分析</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 检测流程 -->
    <section class="detection-process">
      <div class="container">
        <h2 class="section-title">检测流程</h2>
        <div class="process-timeline">
          <div class="process-step">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3>预约咨询</h3>
              <p>在线预约或电话咨询，了解检测项目和注意事项</p>
            </div>
          </div>
          <div class="process-step">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3>信息采集</h3>
              <p>填写健康问卷，提供基本健康信息和病史</p>
            </div>
          </div>
          <div class="process-step">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3>量子检测</h3>
              <p>专业设备进行无创检测，过程约15-30分钟</p>
            </div>
          </div>
          <div class="process-step">
            <div class="step-number">4</div>
            <div class="step-content">
              <h3>数据分析</h3>
              <p>专家团队分析检测数据，生成健康评估报告</p>
            </div>
          </div>
          <div class="process-step">
            <div class="step-number">5</div>
            <div class="step-content">
              <h3>报告解读</h3>
              <p>专业医师解读报告，提供个性化健康建议</p>
            </div>
          </div>
          <div class="process-step">
            <div class="step-number">6</div>
            <div class="step-content">
              <h3>后续服务</h3>
              <p>定期跟踪回访，提供持续的健康管理服务</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术优势 -->
    <section class="advantages">
      <div class="container">
        <h2 class="section-title">技术优势</h2>
        <div class="advantages-grid">
          <div class="advantage-item">
            <div class="advantage-icon">✨</div>
            <h3>无创检测</h3>
            <p>无需抽血、无辐射，完全无创的检测方式，安全舒适</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">⚡</div>
            <h3>快速高效</h3>
            <p>检测过程仅需15-30分钟，当天即可获得初步结果</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">🎯</div>
            <h3>精准可靠</h3>
            <p>采用先进的量子检测设备，准确率高达95%以上</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">🌟</div>
            <h3>全面评估</h3>
            <p>一次性检测全身多个系统，提供全面的健康评估</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">🔮</div>
            <h3>早期预警</h3>
            <p>能够在疾病早期发现潜在风险，提前预防干预</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">📈</div>
            <h3>动态监测</h3>
            <p>可定期重复检测，动态监测健康状况变化</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 适用人群 -->
    <section class="target-audience">
      <div class="container">
        <h2 class="section-title">适用人群</h2>
        <div class="audience-groups">
          <div class="audience-group">
            <h3>👨‍💼 白领人士</h3>
            <p>长期久坐、工作压力大的办公室人群，需要定期健康监测</p>
          </div>
          <div class="audience-group">
            <h3>👴 中老年人群</h3>
            <p>关注慢性病预防，需要全面健康评估的中老年朋友</p>
          </div>
          <div class="audience-group">
            <h3>🏃‍♂️ 运动爱好者</h3>
            <p>需要监测身体状态，优化运动效果的运动人群</p>
          </div>
          <div class="audience-group">
            <h3>👨‍👩‍👧‍👦 家庭用户</h3>
            <p>关注全家健康，希望进行预防性健康检查的家庭</p>
          </div>
          <div class="audience-group">
            <h3>💼 企业员工</h3>
            <p>企业为员工提供的健康福利，团体健康检测服务</p>
          </div>
          <div class="audience-group">
            <h3>🧘‍♀️ 健康追求者</h3>
            <p>追求高品质生活，重视健康管理的健康意识强者</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 预约信息 -->
    <section class="booking-info">
      <div class="container">
        <div class="booking-content">
          <div class="booking-text">
            <h2>立即预约检测</h2>
            <p>专业的量子健康检测服务，为您的健康保驾护航。现在预约还可享受优惠价格。</p>
            <div class="booking-features">
              <div class="feature">✓ 专业医师团队</div>
              <div class="feature">✓ 先进检测设备</div>
              <div class="feature">✓ 个性化报告解读</div>
              <div class="feature">✓ 后续健康跟踪</div>
            </div>
          </div>
          <div class="booking-actions">
            <button @click="goToBooking" class="btn-primary">立即预约</button>
            <button @click="contactUs" class="btn-secondary">咨询客服</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关于我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;" @click=" window.open('https://beian.miit.gov.cn/', '_blank', 'noopener noreferrer');">© 2026 北京和合网链科技发展有限公司 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HealthDetectionDetail',
  data() {
    return {
      phone: '',
      login: false
    }
  },
  methods: {
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    },
    goToBooking() {
      // 跳转到预约页面或首页预约区域
      this.$router.push('/');
      // 或者滚动到首页的预约区域
      setTimeout(() => {
        const element = document.getElementById('appointment');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    },
    contactUs() {
      // 跳转到联系页面或首页联系区域
      this.$router.push('/');
      setTimeout(() => {
        const element = document.getElementById('contact');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }
}
</script>

<style  lang="scss" scoped>
.health-detection-detail {
  padding-top: 80px; /* 为fixed导航栏留出空间 */
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.logo img {
  height: 40px;
  margin-right: 8px;
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}



/* 页面标题 */
.page-header {
  background: linear-gradient(135deg, #1890FF 0%, #40a9ff 100%);
  color: white;
  text-align: center;
  padding: 4rem 2rem;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  color: #333;
}

/* 服务概述 */
.service-overview {
  padding: 4rem 0;
  background: #f8f9fa;
}

.overview-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.overview-text h2 {
  font-size: 1.8rem;
  color: #1890FF;
  margin-bottom: 1.5rem;
}

.overview-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

.detection-illustration {
  height: 300px;
  background: linear-gradient(45deg, #1890FF, #40a9ff);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.quantum-wave {
  position: absolute;
  width: 200px;
  height: 200px;
  border: 3px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.human-body {
  width: 100px;
  height: 200px;
  background: rgba(255,255,255,0.9);
  border-radius: 50px 50px 20px 20px;
  position: relative;
  z-index: 2;
}

@keyframes pulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.7; }
  100% { transform: scale(1); opacity: 1; }
}

/* 技术原理 */
.technology-principle {
  padding: 4rem 0;
}

.principle-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.principle-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  text-align: center;
  transition: transform 0.3s;
}

.principle-card:hover {
  transform: translateY(-5px);
}

.principle-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.principle-card h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

.principle-card p {
  color: #666;
  line-height: 1.6;
}

/* 检测项目 */
.detection-items {
  padding: 4rem 0;
  background: #f8f9fa;
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.item-category {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
}

.item-category h3 {
  color: #1890FF;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.item-category ul {
  list-style: none;
  padding: 0;
}

.item-category li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  color: #555;
}

.item-category li:last-child {
  border-bottom: none;
}

.item-category li:before {
  content: "✓";
  color: #1890FF;
  font-weight: bold;
  margin-right: 0.5rem;
}

/* 检测流程 */
.detection-process {
  padding: 4rem 0;
}

.process-timeline {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.process-step {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.step-number {
  background: #1890FF;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content h3 {
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.step-content p {
  color: #666;
  line-height: 1.6;
}

/* 技术优势 */
.advantages {
  padding: 4rem 0;
  background: #f8f9fa;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.advantage-item {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  text-align: center;
}

.advantage-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.advantage-item h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

.advantage-item p {
  color: #666;
  line-height: 1.6;
}

/* 适用人群 */
.target-audience {
  padding: 4rem 0;
}

.audience-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.audience-group {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  text-align: center;
}

.audience-group h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.audience-group p {
  color: #666;
  line-height: 1.6;
}

/* 预约信息 */
.booking-info {
  background: linear-gradient(135deg, #1890FF 0%, #40a9ff 100%);
  color: white;
  padding: 4rem 0;
}

.booking-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
  align-items: center;
}

.booking-text h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.booking-text p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.booking-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.feature {
  padding: 0.5rem 0;
}

.booking-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.btn-primary, .btn-secondary {
  padding: 1rem 2rem;
  border: none;
  border-radius: 25px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  text-decoration: none;
}

.btn-primary {
  background: white;
  color: #1890FF;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.btn-secondary {
  background: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: white;
  color: #1890FF;
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    display: none;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .overview-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .booking-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>